import { render, staticRenderFns } from "./ValidationErrorsList.vue?vue&type=template&id=65723882&scoped=true&"
import script from "./ValidationErrorsList.vue?vue&type=script&lang=js&"
export * from "./ValidationErrorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65723882",
  null
  
)

export default component.exports